import { useLayoutEffect, useState } from 'react'

export const useListContainerHeight = (
    ref: React.RefObject<HTMLElement>,
    changesLength: number
) => {
    const [height, setHeight] = useState(500)

    useLayoutEffect(() => {
        const updateHeight = () => {
            const container = ref.current?.parentElement
            if (container) {
                setHeight(Math.max(200, container.clientHeight - 10))
            }
        }

        updateHeight()
        window.addEventListener('resize', updateHeight)
        return () => window.removeEventListener('resize', updateHeight)
    }, [changesLength])

    return { height }
}
